module.exports = __webpack_public_path__ + "media/img/pages/companies/hes-so-0bca82e21e719f18a744d135daa5aff8.webp";